<template>
  <div class="admin-project-myproject-container">
    <el-form :inline="true" :model="updateVideoSearch" class="demo-form-inline">
      <el-form-item label="日期">
        <el-date-picker v-model="updateVideoSearch.time" type="date" format="yyyy 年 MM 月 dd 日">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="类型">
        <el-select clearable v-model="updateVideoSearch.videoType">
          <el-option v-for="(item,index) in lookType" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="运动状态">
        <el-select clearable v-model="updateVideoSearch.liftSpeed">
          <el-option :key="1" :value="0" label="没运动"></el-option>
          <el-option :key="2" :value="1" label="在运动"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="searchElevator" class="searchBtn">搜索</el-button>
        <el-button type="warning" @click="reast">重置</el-button>
        <!-- <el-button
          type="primary"
          @click="batchUpload"
        >批量上传</el-button> -->
      </el-form-item>
    </el-form>
    <el-table ref="updateVideoList" :data="updateVideoList" v-loading="loading" stripe fit highlight-current-row
      row-key="id" @select="handleSelectionChange" @select-all="selectAll">
      <el-table-column label="序号" type="index" width="60px" align="center" />
      <el-table-column align="center" prop="file_name" label="文件名称" min-width="150px" />
      <el-table-column label="类型">
        <template slot-scope="scope">
          <!-- {{propmt(scope.row.file_name)}} -->
          {{scope.row.video_type == 1 ? '可见光' : '热成像'}}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="文件上传进度" min-width="80px">
        <template slot-scope="scope">
          <span v-if="!scope.row.upload"> 未上传 </span>
          <span v-else>{{scope.row.upload}}</span>
        </template>
      </el-table-column> -->

      <el-table-column align="center" prop="address" label="操作" fixed="right" width="300px">
        <template slot-scope="scope">
          <el-button v-if="!scope.row.upload" @click="update(scope.row.file_name, scope.row)" type="primary"
            size="small">上传
          </el-button>
          <p v-else style="margin: 7px 0">已请求</p>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    head
  } from 'lodash'
  export default {
    components: {},
    props: {
      Id: {
        type: String,
        default: '',
      },
      deviceCode: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        lookType: [{
          value: 1,
          label: '可见光'
        }, {
          value: 2,
          label: '红外光'
        }], //类型

        visible: false,
        loading: true,
        updateVideoSearch: {
          time: '',
          head: '',
          liftSpeed: ''
        },
        updateVideoList: [],
        newUpdateVideoLis: [],
        initArr: [],
        havePersonDay: '',
        upload: '0%', // 上传进度
        i: 0,
      }
    },
    mounted() {
      this.updateVideoSearch.time = new Date()
    },
    methods: {
      propmt(str) {
        const data = str.split("")
        return data[data.length - 3] + data[data.length - 2] + data[data.length - 1]
      },
      //全选
      selectAll(selection) {
        this.initArr = selection
      },

      handleSelectionChange(val, row) {
        if (this.initArr.find((item) => item.id === row.id)) {
          this.initArr = this.initArr.filter((item) => item.id !== row.id)
        } else {
          this.initArr.push(row)
        }
      },

      // 获取视频列表
      searchElevator() {
        this.newUpdateVideoLis = []
        this.loading = true
        if (!this.updateVideoSearch.time) {
          this.$message.error('请选择日期')
          this.loading = false
          return
        }
        // 转换格式
        let y = this.updateVideoSearch.time.getFullYear()
        let m = this.updateVideoSearch.time.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let d = this.updateVideoSearch.time.getDate()
        d = d < 10 ? '0' + d : d
        const day = `${y}${m}${d}`
        this.havePersonDay = `${y}-${m}-${d}`

        if (this.socketApiCarport.stopCarportHeartBeat) {
          const agentData = {
            act: 'server_push_get_local_video_list',
            token: JSON.parse(sessionStorage.getItem('adminInfo')).token.token,
            startTime: `${day}000000`,
            endTime: `${day}235959`,
            videoType: this.updateVideoSearch.videoType,
            deviceId: this.deviceCode,
          }
          this.socketApiCarport.sendCarportSock(agentData, (e) => {
            console.log(e, '上传视频列表')
            if (e.cmd === 'server_push_get_local_video_list' && e.status) {
              this.updateVideoList = e.data

              this.loading = false
              if ((this.updateVideoSearch.head !== '' || this.updateVideoSearch.liftSpeed !== '')) {
                this.newUpdateVideoLis = this.updateVideoList
                if (this.updateVideoSearch.head !== '') {
                  this.newUpdateVideoLis = this.newUpdateVideoLis.filter(item => item.head !== '' && this
                    .updateVideoSearch.head == item.head)
                }
                if (this.updateVideoSearch.liftSpeed !== '') {
                  this.newUpdateVideoLis = this.newUpdateVideoLis.filter(item => item.liftSpeed !== '' && this
                    .updateVideoSearch.liftSpeed == item.liftSpeed)
                }

              } else {
                this.newUpdateVideoLis = this.updateVideoList
              }
            } else {
              this.updateVideoList = []
              this.loading = false
              this.$message(e.msg)
            }
          })
        }
      },
      reast() {
        this.updateVideoSearch.head = ''
        this.updateVideoSearch.liftSpeed = ''
        this.updateVideoSearch.time = new Date()
        this.updateVideoSearch.videoType = ''
        this.searchElevator()
        // 转换格式
      },

      // 上传
      update(url, row) {
        console.log(this.newUpdateVideoLis, 'newUpdateVideoLis')
        this.$set(
          this.newUpdateVideoLis.find((item) => item.file_md5 === row.file_md5),
          'upload',
          '0%'
        )
        const urlArr = [url]
        const data = {
          deviceId: this.deviceCode,
          fileList: urlArr,
          type: 1,
          md5: row.file_md5,
          talkBackId: row.file_md5,
        }
        this.$http.post('/api/bike/web/bikeLog/pushFile', data).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg)
            // 循环调用获取进度
            // this.timer = setInterval(() => {
            //   // this.get_progress(row)
            // }, 5 * 1000)
          } else {
            this.$set(
              this.equipmentList.find((item) => item.Path === row.Path),
              'upload',
              ''
            )
            this.$message.error(res.data.msg)
          }
        })
      },

      // get_progress(row) {
      //   this.i++
      //   this.$http
      //     .get(`/api/group1/uploadGetProgress?X-Progress-ID=${row.file_md5}`)
      //     .then((res) => {
      //       if (res.data) {
      //         const data = res.data

      //         if (data.status === 'uploading') {
      //           this.upload = `${data.message}%`
      //           this.$set(
      //             this.newUpdateVideoLis.find(
      //               (item) => item.file_md5 === row.file_md5
      //             ),
      //             'upload',
      //             this.upload
      //           )
      //         }
      //         // 上传开始
      //         if (data.status === 'starting') {
      //           this.upload = '50%'

      //           this.$set(
      //             this.newUpdateVideoLis.find(
      //               (item) => item.file_md5 === row.file_md5
      //             ),
      //             'upload',
      //             this.upload
      //           )
      //         }
      //         // 上传开始
      //         // if (data.status === '') {
      //         //   const num = this.i * 5 < 100 ? this.i * 5 : 99
      //         //   this.upload = `${num}%`

      //         //   this.$set(
      //         //     this.updateVideoList.find(
      //         //       (item) => item.file_md5 === row.file_md5
      //         //     ),
      //         //     'upload',
      //         //     this.upload
      //         //   )
      //         // }
      //         // 上传完成
      //         if (data.status === 'ok') {
      //           this.i = 0
      //           this.upload = '100%'
      //           this.$set(
      //             this.newUpdateVideoLis.find(
      //               (item) => item.file_md5 === row.file_md5
      //             ),
      //             'upload',
      //             this.upload
      //           )
      //           clearInterval(this.timer)
      //         }
      //         // 删除定时器对应md5的上传文件
      //         if (this.upload === '100%') {
      //           clearInterval(this.timer)
      //         }
      //       }
      //     })
      // },

      // 批量上传
      batchUpload() {},

      updateVideoDialogClose() {
        this.$refs.updateVideoList.setCurrentRow()
        this.$refs.updateVideoList.clearSelection()
      },
    },
  }
</script>
<style lang="scss" scoped>
  /deep/.el-loading-mask {
    background-color: #7474744d !important;
  }
</style>